
import React, { useEffect, useState } from "react";
import { Box, Button, useMediaQuery } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const leftImages = ["pic1.jpeg", "pic2.jpeg", "pic3.jpeg"];
const rightImages = ["pic4.jpeg", "pic5.jpeg", "pic6.jpeg", "pic7.jpeg"];

const Login = () => {
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width: 760px)");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user")) || null;

    if (user?.accessToken) {
      if (user.userRole?.[0] === "SUPERADMIN") {
        navigate("/superadmin-dashboard");
      } else {
        navigate("/modules");
      }
    }
  }, [navigate]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/signin`,
        {
          username: data.username,
          password: data.password,
        }
      );

      localStorage.setItem("user", JSON.stringify(res.data));

      if (res.data.userRole[0] === "SUPERADMIN") {
        navigate("/superadmin-dashboard");
      } else if (res.data.userRole[0] === "ADMIN") {
        const org = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${encodeURIComponent(
            res.data.username
          )}`,
          {
            headers: {
              Authorization: `Bearer ${res.data.accessToken}`,
            },
          }
        );

        localStorage.setItem("org", JSON.stringify(org.data.orgId));

        if (!org.data.orgUsername && !org.data.orgShortform) {
          navigate("/admin/org-details");
        } else {
          navigate("/modules");
        }
      } else {
        navigate("/modules");
      }
    } catch (error) {
      setError("Login failed. Invalid user ID or password.");
    } finally {
      setLoading(false);
    }
  };

  const desktopImageStyle = {
    position: "fixed",
    width: "180px",
    height: "180px",
    objectFit: "contain",
    zIndex: 100,
    pointerEvents: "none",
  };

  return (
    <div
      className="App"
      style={{
        position: "relative",
      }}
    >
      {/* Desktop product images */}
      {!isMobile && (
        <>
          {/* Left side */}
          <img
            src="/assets/pic1.jpeg"
            alt=""
            width="180"
            height="180"
            style={{
              ...desktopImageStyle,
              left: "3%",
              top: "1%",
            }}
          />

          <img
            src="/assets/pic2.jpeg"
            alt=""
            width="180"
            height="180"
            style={{
              ...desktopImageStyle,
              left: "8%",
              top: "34%",
            }}
          />

          <img
            src="/assets/pic3.jpeg"
            alt=""
            width="180"
            height="180"
            style={{
              ...desktopImageStyle,
              left: "13%",
              bottom: "1%",
            }}
          />

          {/* Right side */}
          <img
            src="/assets/pic4.jpeg"
            alt=""
            width="180"
            height="180"
            style={{
              ...desktopImageStyle,
              right: "5%",
              top: "1%",
            }}
          />

          <img
            src="/assets/pic5.jpeg"
            alt=""
            width="180"
            height="180"
            style={{
              ...desktopImageStyle,
              right: "7%",
              top: "34%",
            }}
          />

          <img
            src="/assets/pic6.jpeg"
            alt=""
            width="180"
            height="180"
            style={{
              ...desktopImageStyle,
              right: "12%",
              bottom: "1%",
            }}
          />

          {/* Seventh image: centered along the bottom */}
          <img
            src="/assets/pic7.jpeg"
            alt=""
            width="180"
            height="180"
            style={{
              ...desktopImageStyle,
              left: "50%",
              bottom: "1%",
              transform: "translateX(-50%)",
              zIndex: 1,
            }}
          />
        </>
      )}

      {loading && <div className="loading-div"></div>}

      {/* Existing login form */}
      <div
        className="border-container"
        style={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <img
          src="/assets/geon-logo.jpg"
          alt="Geon Green Energy On"
          style={{
            display: "block",
            width: 150,
            maxWidth: "100%",
            height: "auto",
            margin: "0 auto 12px",
            objectFit: "contain",
          }}
        />

        <h2>Login</h2>

        <form onSubmit={handleLogin}>
          <label htmlFor="username">Email ID</label>
          <input
            type="email"
            name="username"
            id="username"
            onChange={handleChange}
            required
          />

          <label htmlFor="password">Password</label>
          <input
            type="password"
            name="password"
            id="password"
            onChange={handleChange}
            required
          />

          {error && <span className="error">{error}</span>}

          <div style={{ display: "flex", justifyContent: "end" }}>
            <a href="/forgot-password" style={{ fontSize: "12px" }}>
              Forgot Password?
            </a>
          </div>

          <Button
            type="submit"
            className="btn-contained"
            sx={{ width: "100% !important" }}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </Button>
        </form>
      </div>

      {/* Mobile gallery */}
      {isMobile && (
        <Box
          aria-label="Geon product gallery"
          sx={{
            position: "relative",
            zIndex: 1,
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: 2,
            width: "min(100%, 360px)",
            mx: "auto",
            mt: 3,
            px: 1,
            pb: 2,
          }}
        >
          {[...leftImages, ...rightImages].map((name) => (
            <img
              key={name}
              src={`/assets/${name}`}
              alt="Geon energy product"
              width="160"
              height="140"
              style={{
                display: "block",
                width: "100%",
                height: "140px",
                objectFit: "contain",
              }}
            />
          ))}
        </Box>
      )}
    </div>
  );
};

export default Login;
